import styled from 'styled-components';

export const Divider = styled.hr`
    border-top: 1px solid #eee;
    margin: 0 16px;
`;